import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, TrendingUp, ShieldCheck, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function PortalCreditRepair() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/portal/credit-repair").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>;

  const d = data || {};
  const s = d.latest_score || {};

  return (
    <div className="space-y-8" data-testid="portal-credit-repair">
      <header>
        <div className="eyebrow">My Credit Repair</div>
        <h1 className="mt-2 text-4xl">Anew Credit Repair</h1>
        <p className="mt-2 text-navy/65">Your dispute progress, score history, and notes — synced from our credit repair system.</p>
      </header>

      {!d.enrolled ? (
        <div className="card p-10 text-center" data-testid="cr-not-enrolled">
          <ShieldCheck className="w-10 h-10 text-gold mx-auto" />
          <h3 className="mt-3 text-2xl">You&apos;re not enrolled yet.</h3>
          <p className="mt-2 text-navy/65 max-w-md mx-auto">
            Complete the Anew Credit Repair onboarding to start your dispute journey. Your progress will appear here automatically.
          </p>
          <a
            href={BRAND.cdmSignupUrl}
            target="_blank" rel="noreferrer"
            data-testid="cr-enroll-cta"
            className="btn-primary mt-6 inline-flex"
          >
            Start Onboarding <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      ) : (
        <>
          <div className="grid sm:grid-cols-3 gap-4">
            <div className="card p-5" data-testid="cr-score-experian">
              <div className="text-xs uppercase tracking-widest text-navy/55">Experian</div>
              <div className="font-serif text-4xl text-navy mt-2">{s.experian ?? "—"}</div>
            </div>
            <div className="card p-5" data-testid="cr-score-equifax">
              <div className="text-xs uppercase tracking-widest text-navy/55">Equifax</div>
              <div className="font-serif text-4xl text-navy mt-2">{s.equifax ?? "—"}</div>
            </div>
            <div className="card p-5" data-testid="cr-score-transunion">
              <div className="text-xs uppercase tracking-widest text-navy/55">TransUnion</div>
              <div className="font-serif text-4xl text-navy mt-2">{s.transunion ?? "—"}</div>
            </div>
          </div>

          <div className="card p-7">
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-2xl">Disputes</h3>
              <TrendingUp className="w-5 h-5 text-gold" />
            </div>
            {(d.disputes || []).length === 0 ? (
              <p className="text-navy/55 text-sm">No disputes filed yet. The team will get to work soon.</p>
            ) : (
              <ul className="divide-y divide-navy/5">
                {d.disputes.map((dp, i) => (
                  <li key={dp.dispute_id || i} className="py-3 flex items-center justify-between text-sm" data-testid={`cr-dispute-${i}`}>
                    <div>
                      <div className="text-navy">{dp.item || "Disputed item"}</div>
                      <div className="text-xs text-navy/55">{dp.bureau || "—"} · Round {dp.round || 1}</div>
                    </div>
                    <span className="text-xs uppercase tracking-widest text-gold">{dp.status}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </>
      )}
    </div>
  );
}
